// import { apiSlice } from "../../app/api/apiSlice";

import { apiSlice } from "../../api/apiSlice";

export const FeatureModelApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getFeatureModel: builder.query({
      query: ({ limit, page, search }) =>
        `/api/v1/admin/feature/listing?page=${page}&limit=${limit}&search=${encodeURIComponent(
          search
        )}`,
      providesTags: (result, error) => [{ type: "FeatureModel" }],
    }),
    createFeatureModel: builder.mutation({
      query: (data) => {
        return {
          url: "/api/v1/admin/feature",
          method: "POST",
          body: data,
          // headers: {
          //   "Content-Type": "multipart/form-data",
          // },
        };
      },
      invalidatesTags: ["FeatureModel"],
    }),

    getFeatureModelById: builder.query({
      query: (id) => `/api/v1/admin/feature/${id}`,
      providesTags: (result, error, id) => [{ type: "FeatureModel", id }],
    }),

    updateFeatureModel: builder.mutation({
      query: ({ id, data }) => {
        return {
          url: `/api/v1/admin/feature/${id}`,
          method: "PATCH",
          body: data,
        };
      },
      invalidatesTags: ["FeatureModel"],
    }),

    deleteFeatureModel: builder.mutation({
      query: (id) => ({
        url: `/api/v1/admin/feature/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["FeatureModel"],
    }),
  }),
});

export const {
  useGetFeatureModelQuery,
  useCreateFeatureModelMutation,
  useUpdateFeatureModelMutation,
  useGetFeatureModelByIdQuery,
  useDeleteFeatureModelMutation,
} = FeatureModelApiSlice;
